import React from 'react'
import moment from 'moment'

export default ({ isMobile, banner, endedAt }) =>
  !isMobile ? (
    <div className={`site-header__sponsoredmatch ${banner.backgroundColor}`}>
      <div className="site-header__sponsoredmatch-container">
        {endedAt !== null &&
          banner.isLimited && (
            <div className="site-header__sponsoredmatch-catch-box">
              <div className="site-header__sponsoredmatch_catch">
                <span className="site-header__sponsoredmatch_catch_text">
                  {i18n.t('page.banner.catch-text')}
                </span>
              </div>
              <div className="site-header__sponsoredmatch_date">
                <div className="site-header__sponsoredmatch_date-box">
                  <div className="site-header__sponsoredmatch_date1-inner">
                    <p className="site-header__sponsoredmatch_date1_element">
                      {moment(endedAt).format(
                        i18n.t('page.shared.dateFormat3'),
                      )}
                    </p>
                  </div>
                  <div className="site-header__sponsoredmatch_date2-inner">
                    <p className="site-header__sponsoredmatch_date2_element">
                      {i18n.t('page.banner.catch-text-element')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        <div className="site-header__sponsoredmatch-description-box">
          <div className="site-header__sponsoredmatch-title-box">
            <h2 className="site-header__sponsoredmatch-title">
              {banner.title}
            </h2>
            <div className="site-header__sponsoredmatch-lead">
              {banner.subtitle}
            </div>
          </div>
          <div className="site-header__sponsoredmatch-button-box">
            <div className="site-header__sponsoredmatch-button-inner">
              <div className="site-header__sponsoredmatch-button-detail">
                <a href={banner.externalUrl}>
                  {i18n.t('page.banner.button-detail')}
                </a>
              </div>
              {banner.searchQuery && (
                <div className="site-header__sponsoredmatch-button-space">
                  <a href={banner.searchQuery}>
                    {i18n.t('page.banner.button-space')}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <a href={banner.externalUrl}>
        <div
          className={`site-header__sponsoredmatch ${banner.backgroundColor}`}
        >
          <div className="site-header__sponsoredmatch-container">
            {endedAt !== null &&
              banner.isLimited && (
                <div className="site-header__sponsoredmatch-catch-box">
                  <div className="site-header__sponsoredmatch_catch">
                    <span className="site-header__sponsoredmatch_catch_text">
                      {i18n.t('page.banner.catch-text')}
                    </span>
                  </div>
                  <div className="site-header__sponsoredmatch_date">
                    <div className="site-header__sponsoredmatch_date-box">
                      <div className="site-header__sponsoredmatch_date1-inner">
                        <p className="site-header__sponsoredmatch_date1_element">
                          {moment(endedAt).format(
                            i18n.t('page.shared.dateFormat3'),
                          )}
                        </p>
                      </div>
                      <div className="site-header__sponsoredmatch_date2-inner">
                        <p className="site-header__sponsoredmatch_date2_element">
                          {i18n.t('page.banner.catch-text-element')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            <div className="site-header__sponsoredmatch-description-box">
              <div className="site-header__sponsoredmatch-title-box">
                <h2 className="site-header__sponsoredmatch-title">
                  {banner.title}
                </h2>
                <div className="site-header__sponsoredmatch-lead">
                  {banner.subtitle}
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  )



// WEBPACK FOOTER //
// ./src/components/organisms/MustHeader.js